// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LanguageChangePopup__language-items-c76964 {
  flex: 1;
  overflow: auto;
  padding: 8px 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/LanguageChangePopup/LanguageChangePopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;EACA,iBAAA;AACF","sourcesContent":[".language-items {\n  flex: 1;\n  overflow: auto;\n  padding: 8px 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"language-items": `LanguageChangePopup__language-items-c76964`,
	"languageItems": `LanguageChangePopup__language-items-c76964`
};
module.exports = ___CSS_LOADER_EXPORT___;
